(function () {
  var threshold = window.jellyFreeShippingThreshold || 12000;

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateShippingBar(totalPriceCents) {
    var bar = document.querySelector('[data-shipping-bar]');
    var text = document.querySelector('[data-shipping-text]');
    var fill = document.querySelector('[data-shipping-fill]');
    if (!bar || !text || !fill) return;
    var remaining = threshold - totalPriceCents;
    var pct = Math.min(100, (totalPriceCents / threshold) * 100);
    fill.style.width = pct + '%';
    text.innerHTML = remaining > 0
      ? 'Plus que <b>' + formatMoney(remaining) + '</b> pour la livraison offerte 🎁'
      : '🎉 Livraison offerte débloquée !';
  }

  function refreshCart() {
    fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateShippingBar(cart.total_price);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: cart.item_count } }));
      });
  }

  document.querySelectorAll('[data-cart-item]').forEach(function (row) {
    var key = row.dataset.key;
    var qtyVal = row.querySelector('[data-qty-value]');

    row.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var current = parseInt(qtyVal.textContent, 10);
        var next = Math.max(0, current + parseInt(btn.dataset.qtyChange, 10));
        fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: next }),
        }).then(function () { window.location.reload(); });
      });
    });

    var removeLink = row.querySelector('[data-cart-remove]');
    if (removeLink) {
      removeLink.addEventListener('click', function () {
        fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        }).then(function () { window.location.reload(); });
      });
    }
  });

  document.querySelectorAll('[data-addon-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function () { window.location.reload(); })
        .catch(function () { btn.disabled = false; });
    });
  });

  refreshCart();
})();
